import React, { useState, useEffect } from "react";
import "../../assets/css/UserGuide/UserGuide.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTimes, faDownload } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { BASE_URL } from "../../store/config";
import { Document, Page, pdfjs } from "react-pdf";






pdfjs.GlobalWorkerOptions.workerSrc =
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function UserGuide() {

  const [guides, setGuides] = useState([]);
  const [selectedGuide, setSelectedGuide] = useState(null);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("date-desc");

  useEffect(() => {
    fetchGuides();
  }, []);

  const fetchGuides = async () => {
    try {

      const token = localStorage.getItem("access_token");

      const response = await axios.get(
        `${BASE_URL}api/user-guide-assignments/my-guides`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data);
      setGuides(response.data || []);

    } catch (error) {
      console.error("Error fetching guides:", error);
    } finally {
      setLoading(false);
    }
  };

  // Search
  const filteredGuides = guides.filter((guide) =>
    guide.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Sort
  const sortedGuides = [...filteredGuides].sort((a, b) => {

    if (sortOption === "name-asc") {
      return a.title.localeCompare(b.title);
    }

    if (sortOption === "name-desc") {
      return b.title.localeCompare(a.title);
    }

    if (sortOption === "date-asc") {
      return new Date(a.created_at) - new Date(b.created_at);
    }

    if (sortOption === "date-desc") {
      return new Date(b.created_at) - new Date(a.created_at);
    }

    return 0;
  });

  if (loading) {
    return (
      <div className="ug-section">
        <p>Loading guides...</p>
      </div>
    );
  }

  return (
    <div className="ug-section">

      {/* SEARCH + SORT */}
      <div className="ug-controls">

        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="ug-search"
        />

        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className="ug-sort"
        >
          <option value="date-desc">Newest First</option>
          <option value="date-asc">Oldest First</option>
          <option value="name-asc">Name (A-Z)</option>
          <option value="name-desc">Name (Z-A)</option>
        </select>

      </div>

      {/* GUIDE GRID */}
      <div className="ug-grid">

        {sortedGuides.length === 0 ? (

          <div className="empty-userguide">
            <div className="empty-guide-card">

              <div className="empty-guide-icon">📘</div>

              <h2>No User Guides Assigned Yet</h2>

              <p className="empty-guide-subtitle">
                User guides and learning materials assigned to you will appear here.
              </p>

              <blockquote>
                “Learning never exhausts the mind.”
              </blockquote>

              <a
                href="https://www.ssdntech.com/corporate-training"
                target="_blank"
                rel="noopener noreferrer"
                className="btn primary external-link"
              >
                Explore Training ↗
              </a>

              <p className="empty-guide-hint">
                Stay tuned for upcoming guides and documentation ✨
              </p>

            </div>
          </div>

        ) : (

          sortedGuides.map((guide) => (

            <div className="ug-card" key={guide.id}>

              {/* PDF THUMBNAIL */}
              <div className="ug-image">
                {guide.file_path ? (
                  <Document
                    file={`${BASE_URL}api/${guide.file_path}`}
                    loading={<div>Loading preview...</div>}
                    onLoadError={(error) => console.error("PDF load error:", error)}
                  >
                    <Page
                      pageNumber={1}
                      width={250}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
                ) : (
                  <div style={{ padding: "40px", textAlign: "center" }}>
                    No Preview
                  </div>
                )}
              </div>
              {/* CONTENT */}
              <div className="ug-content">

                <h4>{guide.title}</h4>

                <p>
                  Date: {new Date(guide.created_at).toLocaleDateString()}
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                    marginTop: "10px"
                  }}
                >

                  {/* VIEW MODAL */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      cursor: "pointer"
                    }}
                    onClick={() => setSelectedGuide(guide)}
                  >
                    <FontAwesomeIcon icon={faEye} />
                    <span>View</span>
                  </div>

                  {/* DOWNLOAD PDF */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      cursor: "pointer"
                    }}
                    onClick={async () => {
                      try {
                        const token = localStorage.getItem("access_token");

                        const response = await axios.get(
                          `${BASE_URL}api/${guide.file_path}`,
                          {
                            responseType: "blob",
                            headers: {
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        );

                        // Create downloadable file
                        const url = window.URL.createObjectURL(
                          new Blob([response.data])
                        );

                        const link = document.createElement("a");
                        link.href = url;

                        // File name
                        link.setAttribute(
                          "download",
                          `${guide.title || "user-guide"}.pdf`
                        );

                        document.body.appendChild(link);
                        link.click();

                        // Cleanup
                        link.remove();
                        window.URL.revokeObjectURL(url);

                      } catch (error) {
                        console.error("Download failed:", error);
                      }
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                    <span>Download Guide</span>
                  </div>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

      {/* PDF MODAL VIEWER */}
      {selectedGuide && (

        <div
          className="ug-modal-overlay"
          onClick={() => setSelectedGuide(null)}
        >

          <div
            className="ug-modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <FontAwesomeIcon
              icon={faTimes}
              className="ug-modal-close"
              onClick={() => setSelectedGuide(null)}
            />

            <iframe
              src={`${BASE_URL}api/${selectedGuide.file_path}`}
              title={selectedGuide.title}
              className="ug-iframe"
            />

          </div>

        </div>

      )}

    </div>
  );
}

export default UserGuide;